import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Spinner,
  Form,
  Button,
  Input,
  Alert,
  Row,
  Col,
  Table,
} from "reactstrap";
import { exportQuotation, getQuotation } from "../../redux/actions/quotation";
import { validItem } from "../../redux/actions/forms";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { hasPermission } from '../../utils/permissions';

function QuotationList() {
  const dispatch = useDispatch();
  const response = useSelector((state) => state.forms.valid);
  const quotations = useSelector((state) => state.quotation.get);
  const download = useSelector((state) => state.quotation.download);
  const [loading, setLoading] = useState(true);
  const [numerointerno, setNumerointerno] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [patente, setPatente] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "BGL - Cotizaciones";
    dispatch(getQuotation({ start: 0, end: 30 }));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (response) {
      if (response.data.exist === true) {
        navigate("/item-quotation", {
          state: {
            data: {
              numerointerno: numerointerno,
              price: response.data.price,
              comission: response.data.comission,
              iva: response.data.iva,
            },
          },
        });
        setNumerointerno("");
      }
      setNumerointerno("");
      setLoading(false);
      setAlertTitle("El bien que esta buscando no existe");
      setAlertType("danger");
      setShowAlert(true);
    }
  }, [response]);

  useEffect(() => {
    if (!quotations) return;
    if (quotations.error) {
      setLoading(false);
      setAlertTitle("Error");
      setAlertMessage(quotations.message);
      setAlertType("danger");
      setShowAlert(true);
      return;
    }
    if (quotations.message === "Quotations") {
      setData(quotations.data);
      setLoading(false);
    }
  }, [quotations]);

  const onDismiss = () => setShowAlert(false);

  const onFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(validItem(numerointerno, patente));
  };

  const goToItem = (item) => {

    navigate("/item-quotation", { state: { data: item } });
  };

  const nextPage = () => {
    let start = (page + 1) * 30;
    setPage(page + 1);
    let end = start + 30;

    dispatch(getQuotation({ start: start, end: end }));
    window.scrollTo(0, 0);
    setLoading(true);
  };

  const previousPage = () => {
    let start = (page - 1) * 30;
    setPage(page - 1);
    let end = start + 30;
    dispatch(getQuotation({ start: start, end: end }));
    window.scrollTo(0, 0);
    setLoading(true);
  };

  const downloadFile = () => {
    dispatch(exportQuotation());
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Container>
        <Alert color={alertType} isOpen={showAlert} toggle={onDismiss}>
          {alertTitle} - {alertMessage}
        </Alert>
      </Container>

      <Container
        className="container-border p-3"
        style={{ marginTop: 20, marginBottom: 20 }}
      >
        {hasPermission('quotations.create') && (
          <h2>Crear Cotizacion</h2>
        )}
        <Form onSubmit={(e) => onFormSubmit(e)}>
          {hasPermission('quotations.create') && (
            <Row>
              <Col>
                <Input
                  className="col-md mt-2"
                  placeholder="NUMERO INTERNO"
                  type="text"
                  value={numerointerno}
                  onChange={(e) => setNumerointerno(e.target?.value)}
                />
              </Col>
              <Col>
                <Input
                  className="col-md mt-2"
                  placeholder="PATENTE"
                  type="text"
                  value={patente}
                  onChange={(e) => setPatente(e.target?.value)}
                />
              </Col>
              <Col>
                <Button className="col-md">Buscar</Button>
              </Col>
            </Row>
          )}
          {hasPermission('quotations.export') && (
            <Button
              className="float-right mb-2"
              onClick={() => {
                downloadFile();
              }}
            >
              Descargar Cotizaciones
            </Button>
          )}
          <h2>Lista de Cotizaciones</h2>
        </Form>
        <Table hover>
          <thead>
            <tr>
              <th>Numero interno</th>
              <th>version</th>
              <th>Nombre</th>
              <th>Precio</th>
              <th>Fecha</th>
              <th>descargar</th>
              <th>Ver</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{row.data.numerointerno}</td>
                  <td>{row.data.version ? row.data.version : "1"}</td>
                  <td>
                    {row.data.sirs === "" ? row.data.name : row.data.sirs}
                  </td>
                  <td>
                    {row.data.price} {row.data.iva}
                  </td>
                  <td>{row.data.date}</td>
                  <td>
                    {
                      <a
                        style={{ width: "100%", color: "white" }}
                        className="btn btn-secondary"
                        target="_blank"
                        href={row.data.pdf}
                      >
                        <i className="fa fa-download"></i>
                      </a>
                    }
                  </td>
                  <td>
                    {hasPermission('quotations.edit') && (
                      <Button
                        onClick={() => {
                          goToItem(row.data);
                        }}
                      >
                        EDITAR
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Button
          className="float-right m-3"
          onClick={() => {
            nextPage();
          }}
        >
          Siguiente
        </Button>
        <Button
          disabled={page <= 0 ? true : false}
          className="m-3"
          onClick={() => {
            previousPage();
          }}
        >
          Anterior
        </Button>
      </Container>
    </>
  );
}
export default QuotationList;
